import React from 'react';
// import PropTypes from 'prop-types';
import { Avatar, Icon, List, ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: '00a0af',
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
  },
  error: {
    backgroundColor: '#FF0303',
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
  }
}));
const PasswordConditionsIndicator = props => {
  // const {numberValid, uppercaseValid, lowercaseValid, specialCharValid, charNumberValid, numberOfCharacters} = props
  const { validators } = props
  const classes = useStyles();
  // console.log('validators', validators)
  return (
    <div className="validation">
      <List dense className={classes.root}>
        {validators.map(row => {
          return <ListItem key={row.id}>
            <ListItemAvatar>
              <Avatar className={row.validationState ? classes.success : classes.error}> <Icon></Icon></Avatar>
            </ListItemAvatar>
            {(row.tittle === 'Caracteres mínimos') ?
              <ListItemText primary={row.tittle + ': ' + row.expression} />
              : (row.tittle === 'Caracter especial') ?
              <ListItemText primary={row.tittle + ': !@#$%^&_.*'}/>
              :  <ListItemText primary={row.tittle}/> }
          </ListItem>

        })}
        {/* <ListItem>
                <ListItemAvatar>
                  <Avatar className={numberValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={'Caracter numérico valido'} />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar className={lowercaseValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={'Letra minúscula'} />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar className={uppercaseValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={'Letra mayúscula'} />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar className={specialCharValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={'Caracter especial'} />
            </ListItem>
            <ListItem>
                <ListItemAvatar>
                  <Avatar className={charNumberValid ? classes.success : classes.error }> <Icon></Icon></Avatar>
                </ListItemAvatar>
                <ListItemText  primary={`Contraseña mínimo ${numberOfCharacters} caracteres`} />
            </ListItem> */}
      </List>
    </div>
  );
};

PasswordConditionsIndicator.propTypes = {
  // numberValid: PropTypes.bool.isRequired,
  // uppercaseValid: PropTypes.bool.isRequired,
  // lowercaseValid: PropTypes.bool.isRequired,
  // specialCharValid: PropTypes.bool.isRequired,
  // charNumberValid: PropTypes.bool.isRequired,
};

export default PasswordConditionsIndicator;
